export default __webpack_public_path__ + "static/media/building.fb61b7de.png";